module.exports = __webpack_public_path__ + "static/img/our-people-we-live-full-img3.56daa32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-full-img3.jpg
// module id = j1cq
// module chunks = 0